import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const PrevRecurringRevenueYearToDate = ({ size }) => {
  const { label, value, url } = useSelector(
    (state) => state.membershipRevenue.membershipDraft.recurring?.prevRecurringRevenueYTD
  );
  const currencySymbol = useSelector(
    (state) => state.membershipRevenue.membershipDraft.currencySymbol
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <DataDisplay
      label={label}
      size={size}
      type="money"
      url={url}
      currency={currencySymbol}
      value={value}
      disableAnimation={isUserQa}
    />
  );
};

export default PrevRecurringRevenueYearToDate;
